import setToken from "./SetToken";
import setDevKey from "./SetDevKey";
import { key } from "./Config";

// Admin sessions (Phase 2) are opaque server-side sessions issued only after
// password + authenticator verification. The token is kept in sessionStorage
// (cleared when the browser tab/window closes) and sent as a Bearer token.
const TOKEN = "ADMIN_SESSION";
const PROFILE = "ADMIN_PROFILE";

// Values left behind by the retired Lark/JWT login.
const LEGACY_KEYS = ["TOKEN", "KEY"];

export const clearLegacySession = () => {
  LEGACY_KEYS.forEach((name) => localStorage.removeItem(name));
};

export const getStoredSession = () => {
  const token = sessionStorage.getItem(TOKEN);
  if (!token || !token.startsWith("vla_")) return null;
  let admin = {};
  try {
    admin = JSON.parse(sessionStorage.getItem(PROFILE) || "{}");
  } catch (error) {
    admin = {};
  }
  return { token, admin };
};

export const storeSession = (token, admin) => {
  sessionStorage.setItem(TOKEN, token);
  sessionStorage.setItem(PROFILE, JSON.stringify(admin || {}));
  applySessionHeaders(token);
};

export const storeProfile = (admin) => {
  sessionStorage.setItem(PROFILE, JSON.stringify(admin || {}));
};

export const applySessionHeaders = (token) => {
  setToken(token ? `Bearer ${token}` : null);
  // The shared key is still required by shared endpoints; it is not a secret
  // and never authorizes admin operations on its own.
  setDevKey(token ? key : null);
};

export const clearSession = () => {
  sessionStorage.removeItem(TOKEN);
  sessionStorage.removeItem(PROFILE);
  clearLegacySession();
  applySessionHeaders(null);
};
